module.exports = __webpack_public_path__ + "static/img/img01.aa2b64d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img01.jpg
// module id = soQ7
// module chunks = 0